import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './needs-goals.component.scss';
var NeedsGoals = /** @class */ (function (_super) {
    tslib_1.__extends(NeedsGoals, _super);
    function NeedsGoals(element) {
        return _super.call(this, element) || this;
    }
    NeedsGoals.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            speed: 800,
            spaceBetween: 30,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    NeedsGoals.prototype.bindEvents = function () { };
    return NeedsGoals;
}(Base));
export { NeedsGoals };



//////////////////
// WEBPACK FOOTER
// ./components/needs-goals/needs-goals.component.ts
// module id = 412
// module chunks = 0